import type { AlertConfigurationRule } from '@rtkwlf/rendall';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useOrganizationContext } from '@packages/legacy/organization-context';
import { SECOND_IN_MS } from 'ae-constants/constants';

import { useRendallApi } from '../use-rendall-api';

export const getAlertConfigurationRulesQueryKey = (organizationId: string) => [
  organizationId,
  'rendall',
  'get-alert-configuration-rules',
];

export function useAlertConfigurationRules<
  Data = Record<string, AlertConfigurationRule | undefined>,
>(
  options?: Omit<
    UseQueryOptions<
      Record<string, AlertConfigurationRule | undefined>,
      unknown,
      Data
    >,
    'queryKey' | 'queryFn'
  >,
) {
  const api = useRendallApi();
  const { selectedOrganization } = useOrganizationContext();

  return useQuery({
    queryFn: () =>
      api.getAlertConfigurationRules({
        organizationId: selectedOrganization.id,
      }),
    queryKey: getAlertConfigurationRulesQueryKey(selectedOrganization.id),
    staleTime: 5 * SECOND_IN_MS,
    ...options,
  });
}
